import React from 'react'
import "./SearchContainer.css"
import { Col, Container, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux';
function SearchContainer({ searchkey, products,categories }) {
      const { currentLocal } = useSelector((state) => state.currentLocal);

  return (
    <div className='search_container'>
      <Container fluid>
        <Row>

          {products?.length !== 0 &&
            <Col md={6}>
              <h6>{currentLocal.home.products}</h6>
              {products && products?.map((item, index) => {
                console.log(item);
                
                return (
                  <Link className='d-flex align-items-center mt-2'key={index} to={`/product/${item.id}`}>
                    <img src={item?.images[0]?.image} alt="" className="w-25 me-1" />

                    <p className='mb-0'>{currentLocal.language=="English"?item?.name_en:item?.name_ar}</p>
                  </Link>

                )
              })}


            </Col>
          }
        </Row>
        {/* <Row className='border-bottom pb-2'>
          <Col md={6}>
          <Link className='d-flex align-items-center mt-2'>
          <img src="https://cobramodafrance.com/cdn/shop/files/5850239194163693028_120x.jpg?v=1730631977" alt="" className="w-25 me-1" />

            <p className='mb-0'>Product1</p>
          </Link>  
          </Col>
          <Col md={6}>
          <Link className='d-flex align-items-center mt-2'>
          <img src="https://cobramodafrance.com/cdn/shop/files/5850239194163693028_120x.jpg?v=1730631977" alt="" className="w-25 me-1" />

            <p className='mb-0'>Product1</p>
          </Link>  
          </Col>
          </Row>

          <Row className='border-bottom pb-2'>
          <Col md={6}>
          <Link className='d-flex align-items-center mt-2'>
          <img src="https://cobramodafrance.com/cdn/shop/files/5850239194163693028_120x.jpg?v=1730631977" alt="" className="w-25 me-1" />

            <p className='mb-0'>Product1</p>
          </Link>  
          </Col>
          <Col md={6}>
          <Link className='d-flex align-items-center mt-2'>
          <img src="https://cobramodafrance.com/cdn/shop/files/5850239194163693028_120x.jpg?v=1730631977" alt="" className="w-25 me-1" />

            <p className='mb-0'>Product1</p>
          </Link>  
          </Col>
          </Row>


          <Row className='border-bottom pb-2'>
          <Col md={6}>
          <Link className='d-flex align-items-center mt-2'>
          <img src="https://cobramodafrance.com/cdn/shop/files/5850239194163693028_120x.jpg?v=1730631977" alt="" className="w-25 me-1" />

            <p className='mb-0'>Product1</p>
          </Link>  
          </Col>
          <Col md={6}>
          <Link className='d-flex align-items-center mt-2'>
          <img src="https://cobramodafrance.com/cdn/shop/files/5850239194163693028_120x.jpg?v=1730631977" alt="" className="w-25 me-1" />

            <p className='mb-0'>Product1</p>
          </Link>  
          </Col>
          </Row>

          <Row className='border-bottom pb-2'>
          <Col md={6}>
          <Link className='d-flex align-items-center mt-2'>
          <img src="https://cobramodafrance.com/cdn/shop/files/5850239194163693028_120x.jpg?v=1730631977" alt="" className="w-25 me-1" />

            <p className='mb-0'>Product1</p>
          </Link>  
          </Col>
          <Col md={6}>
          <Link className='d-flex align-items-center mt-2'>
          <img src="https://cobramodafrance.com/cdn/shop/files/5850239194163693028_120x.jpg?v=1730631977" alt="" className="w-25 me-1" />

            <p className='mb-0'>Product1</p>
          </Link>  
          </Col>
          </Row>
          <Row className='border-bottom pb-2'>
          <Col md={6}>
          <Link className='d-flex align-items-center mt-2'>
          <img src="https://cobramodafrance.com/cdn/shop/files/5850239194163693028_120x.jpg?v=1730631977" alt="" className="w-25 me-1" />

            <p className='mb-0'>Product1</p>
          </Link>  
          </Col>
          <Col md={6}>
          <Link className='d-flex align-items-center mt-2'>
          <img src="https://cobramodafrance.com/cdn/shop/files/5850239194163693028_120x.jpg?v=1730631977" alt="" className="w-25 me-1" />

            <p className='mb-0'>Product1</p>
          </Link>  
          </Col>
          </Row>
          <Row className='border-bottom pb-2'>
          <Col md={6}>
          <Link className='d-flex align-items-center mt-2'>
          <img src="https://cobramodafrance.com/cdn/shop/files/5850239194163693028_120x.jpg?v=1730631977" alt="" className="w-25 me-1" />

            <p className='mb-0'>Product1</p>
          </Link>  
          </Col>
          <Col md={6}>
          <Link className='d-flex align-items-center mt-2'>
          <img src="https://cobramodafrance.com/cdn/shop/files/5850239194163693028_120x.jpg?v=1730631977" alt="" className="w-25 me-1" />

            <p className='mb-0'>Product1</p>
          </Link>  
          </Col>
          </Row>
          <Row className='border-bottom pb-2'>
          <Col md={6}>
          <Link className='d-flex align-items-center mt-2'>
          <img src="https://cobramodafrance.com/cdn/shop/files/5850239194163693028_120x.jpg?v=1730631977" alt="" className="w-25 me-1" />

            <p className='mb-0'>Product1</p>
          </Link>  
          </Col>
          <Col md={6}>
          <Link className='d-flex align-items-center mt-2'>
          <img src="https://cobramodafrance.com/cdn/shop/files/5850239194163693028_120x.jpg?v=1730631977" alt="" className="w-25 me-1" />

            <p className='mb-0'>Product1</p>
          </Link>  
          </Col>
          </Row> */}
      </Container>

    </div>
  )
}

export default SearchContainer